// react
import { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import { KeyboardArrowUp as ArrowUpIcon } from '@mui/icons-material';

// material-ui
import { Box, Drawer, List, ListItem, ListItemButton, ListItemText, Stack } from '@mui/material';
import { Close as CloseIcon, Menu as MenuIcon } from '@mui/icons-material';

// components
import { Container } from 'components';
import MenuTabs from 'components/MenuTabs';

// third-party

// asset
import siteLogo from 'assets/images/wifi-tokyo-logo.png';
import { baseColors } from 'utils/constants';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // スクロール位置を監視
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);
  // ページトップへのスクロール
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Box
      sx={{
        width: '100%',
        borderBottom: '2px solid #e60012',
        backgroundColor: baseColors.white,
        position: { xs: 'sticky', sm: 'relative' },
        top: { xs: 0, sm: 'auto' },
        zIndex: 1000
      }}
    >
      <Container sx={{ height: '75px', position: 'relative' }}>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Stack></Stack>
          <Stack>
            <img
              src={siteLogo}
              alt="logo"
              style={{ width: '195px', position: 'absolute', left: 'calc(50% - 97.5px)', right: 'calc(50% - 97px)', bottom: -2 }}
            />
          </Stack>
          <Stack>
            <List component="nav" sx={{ display: 'flex', justifyContent: 'flex-start', paddingTop: '0px' }}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={handleDrawerOpen}
                  sx={{
                    textAlign: 'center',
                    display: 'block',
                    backgroundColor: baseColors.red,
                    padding: '4px 8px',
                    borderRadius: '5px',
                    outline: 'none', // 初期状態のoutlineを無効化
                    '&:hover, &:focus': {
                      // hoverやfocusの状態をオーバーライド
                      backgroundColor: baseColors.red, // ホバー時の背景色を他の色でも
                      outline: 'none', // outlineを無効化
                      boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.2)' // 代わりにboxShadowを使用
                    }
                  }}
                >
                  <ListItemText primary={<MenuIcon style={{ color: '#ffffff' }} />} />
                </ListItemButton>
              </ListItem>
            </List>
            <Drawer
              anchor="right"
              open={open}
              onClose={handleDrawerClose}
              slotProps={{ paper: { sx: { width: '100%', maxWidth: '400px' } } }}
            >
              <List component="nav" sx={{ display: 'block', justifyContent: 'normal' }}>
                <ListItem disablePadding>
                  <ListItemButton onClick={handleDrawerClose} sx={{ textAlign: 'right', borderBottom: 'none' }}>
                    <ListItemText primary={<CloseIcon />} />
                  </ListItemButton>
                </ListItem>
                <MenuTabs closer={handleDrawerClose} />
              </List>
            </Drawer>
          </Stack>
        </Stack>
      </Container>
      {isVisible && (
        <Fab
          color="primary"
          aria-label="scroll back to top"
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16
          }}
        >
          <ArrowUpIcon />
        </Fab>
      )}
    </Box>
  );
};

export default Header;
